<template>
  <div class="pvd-form-row">
    <div class="form-row-label">
      <label :for="`input${idPostfix}`">
        {{ label }}
      </label>
    </div>
    <div class="form-row-content">
      <input
        :id="`input${idPostfix}`"
        :key="name"
        v-model="inputListeners"
        v-validate="parsedRules"
        :name="name"
        :class="[cssClass, {'input-error': errors.has(name)}]"
        :type="type"
        :maxlength="parsedRules.max"
        :aria-invalid="errors.has(name) ? true: null"
        :aria-describedby="errors.has(name) ? `${idPostfix}Error` : null"
        :data-pii="mask"
        :autocomplete="autocomplete === 'false' ? 'off' : null"
        @keyup="formatSsn"
      >
    </div>
    <div
      v-if="supplementalText !== ''"
      class="form-row-supplemental"
    >
      <p class="xsmall">
        {{ supplementalText }}
      </p>
    </div>
    <InlineMessage
      v-show="errors.has(name)"
      :id-prefix="idPostfix"
      :message="errors.first(name)"
    />
  </div>
</template>

<script>
import { ssn } from '@fmr-ap109253/providence/dist/services/format-input';
import InlineMessage from './InlineMessage.vue';
import utilityFunctions from '../mixins/utility';
import validationHelper from '../mixins/validationHelper';

export default {
  name: 'InputSsn',
  components: { InlineMessage },
  mixins: [utilityFunctions, validationHelper],
  inject: ['$validator'],
  $_veeValidate: {
    value() {
      return this.inputListeners;
    },
    name() {
      return this.name;
    },
  },
  props: {
    cssClass: {
      type: String,
      default: '',
    },
    idPostfix: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    mask: {
      type: String,
      default: 'false',
    },
    message: {
      type: Object,
      default: () => {},
    },
    name: {
      type: String,
      default: '',
    },
    supplementalText: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    validationRules: {
      type: Object,
      default: () => {},
    },
    autocomplete: {
      type: String,
      default: () => '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputListeners: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('update:value', newValue);
      },
    },
    parsedRules() {
      let rules = {};
      if (this.validationRules) {
        rules = this.parseRules(this.validationRules);
      }
      return rules;
    },
  },
  mounted() {
    this.$validator.localize('en', this.buildCustomMessage(this.name, this.message));
  },
  methods: {
    formatSsn(event) {
      ssn(event);
    },
  },
};
</script>

<style lang="scss">
</style>
